<main id="main" class="dataset-info main__offset-header" *ngIf="!loading">
  <section class="dataset-info__floating-header">
    <div class="container">
      <div class="d-flex justify-content-between align-items-center">
        <h1 class="mb-sm-0" [innerHTML]="dataset.name"></h1>
        <div class="d-none d-sm-flex flex-nowrap">
          <a class="btn btn-secondary" routerLink="/access-data">
            Access Data
            <i aria-hidden="true" class="bi bi-cloud-arrow-down"></i>
          </a>
          <a
            class="btn btn-secondary ms-2"
            [routerLink]="'/explore-map/' + dataset.mapServiceURLSlug"
          >
            View on Map
            <i aria-hidden="true" class="bi bi-globe"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
  <section class="container">
    <div class="row gx-5">
      <div class="col-12 col-sm-6">
        <p
          class="lead"
          *ngIf="dataset.mapServiceMetadata.longDescription"
          [innerHTML]="dataset.mapServiceMetadata.longDescription"
        ></p>

        <ng-container *ngIf="dataset.mapServiceMetadata.lastUpdated">
          <h2>Last Update</h2>
          <p [innerHTML]="dataset.mapServiceMetadata.lastUpdated"></p>
        </ng-container>
        <ng-container *ngIf="dataset.mapServiceMetadata.keywords">
          <h2>Keywords</h2>
          <p [innerHTML]="dataset.mapServiceMetadata.keywords"></p>
        </ng-container>
        <ng-container *ngIf="dataset.mapServiceMetadata.themes">
          <h2>Themes</h2>
          <p [innerHTML]="dataset.mapServiceMetadata.themes"></p>
        </ng-container>
        <ng-container
          *ngIf="dataset.mapServiceMetadata.scale && !dataset.mapServiceURLSlug === 'cadastral-all'"
        >
          <h2>Scale</h2>
          <p [innerHTML]="dataset.mapServiceMetadata.scale"></p>
        </ng-container>
        <ng-container
          *ngIf="
            dataset.mapServiceURLSlug === 'cadastral-all' &&
            dataset.mapServiceMetadata.cadastralScale &&
            dataset.mapServiceMetadata.cadastralScale.length
          "
        >
          <h2>Scales</h2>
          <ul class="list-unstyled">
            <li *ngFor="let scale of dataset.mapServiceMetadata.cadastralScale">{{ scale }}</li>
          </ul>
        </ng-container>
        <ng-container *ngIf="dataset.mapServiceMetadata.coordinateSystem">
          <h2>Coordinate System</h2>
          <p [innerHTML]="dataset.mapServiceMetadata.coordinateSystem"></p>
        </ng-container>
        <ng-container *ngIf="dataset.mapServiceMetadata.imageryResolution">
          <h2>Imagery Resolution</h2>
          <p [innerHTML]="dataset.mapServiceMetadata.imageryResolution"></p>
        </ng-container>
        <h2
          *ngIf="
            dataset.supportsWFS ||
            dataset.supportsWMS ||
            dataset.supportsWMTS ||
            dataset.supportsDownload
          "
        >
          Available Formats
        </h2>

        <ng-container *ngIf="dataset.supportsWFS || dataset.supportsWMS || dataset.supportsWMTS">
          <h3 class="h4">Web Services</h3>
          <ul class="list-unstyled dataset-formats">
            <li *ngIf="dataset.supportsWFS">WFS</li>
            <li *ngIf="dataset.supportsWMS">WMS</li>
            <li *ngIf="dataset.supportsWMTS">WMTS</li>
          </ul>
        </ng-container>

        <ng-container
          *ngIf="dataset.downloads && dataset.downloads.length"
        >
          <h3 class="h4">Download</h3>
          <ul class="list-unstyled">
            <li *ngFor="let file of dataset.downloads">
              {{ file.name }}
              <span *ngIf="dataset.mapServiceURLSlug !== 'hvlsp'; else zipText">- {{ file.size }} zip</span>
              <ng-template #zipText>
                <span>(zip)</span>
              </ng-template>
            </li>
          </ul>
        </ng-container>

        <ng-container
          *ngIf="
            dataset.mapServiceMetadata.userDocumentation &&
            dataset.mapServiceMetadata.userDocumentation.length
          "
        >
          <h2>Dataset Documentation</h2>
          <ul class="list-unstyled">
            <li *ngFor="let link of dataset.mapServiceMetadata.userDocumentation">
              <a href="{{ link.url }}" target="_blank">{{ link.title }}</a>
            </li>
          </ul>
        </ng-container>
        <ng-container
          *ngIf="
            dataset.mapServiceURLSlug === 'cadastral-all' &&
            dataset.mapServiceMetadata.cadastralProviderLinks &&
            dataset.mapServiceMetadata.cadastralProviderLinks.length
          "
        >
          <div class="cadastral-provider-links">
            <h2>Data Provider Links</h2>
            <ngb-accordion #acc="ngbAccordion" [closeOthers]="true">
              <ngb-panel
                [title]="item.country"
                [id]="'index_' + i"
                *ngFor="
                  let item of dataset.mapServiceMetadata.cadastralProviderLinks;
                  let i = index
                "
              >
                <ng-template ngbPanelContent>
                  <ul class="list-unstyled mb-0">
                    <li *ngFor="let link of item.links">
                      <a
                        class="btn btn-secondary mb-1 text-left"
                        [href]="link.productURL"
                        target="_blank"
                        >{{ link.product }}
                        <i class="bi bi-box-arrow-up-right ms-1"></i>
                      </a>
                    </li>
                  </ul>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
        </ng-container>
      </div>
      <div class="col-12 col-sm-6">
        <h2>
          Coverage
          <button
            class="btn btn-primary btn-sm d-sm-none"
            type="button"
            href="#countriesList"
            data-bs-toggle="collapse"
            data-bs-target="#countriesList"
            aria-expanded="false"
            aria-controls="countriesList"
          >
            <span class="sr-only">View Countries List</span>
            <i
              class="bi bi-plus-lg"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-delay="200"
              title="View Countries List"
            ></i>
          </button>
        </h2>
        <div class="d-flex flex-column flex-column-reverse d-sm-block">
          <app-dataset-coverage-map
            [countries]="dataset.mapServiceMetadata.coverage"
          ></app-dataset-coverage-map>
          <div class="collapse" id="countriesList">
            <ul class="list-unstyled countries-list">
              <li *ngFor="let country of countryNames | sort" [innerHTML]="country"></li>
            </ul>
            <p
              *ngIf="dataset.mapServiceMetadata.coverageComments"
              [innerHTML]="'* ' + dataset.mapServiceMetadata.coverageComments"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="floating-cta d-sm-none">
    <div class="d-flex justify-content-between">
      <a class="btn btn-secondary" routerLink="/access-data">
        Access Data
        <i aria-hidden="true" class="bi bi-cloud-arrow-down"></i>
      </a>
      <a class="btn btn-secondary ms-3" [routerLink]="'/explore-map/' + dataset.mapServiceURLSlug">
        View on Map
        <i aria-hidden="true" class="bi bi-globe"></i>
      </a>
    </div>
  </section>
</main>
<app-footer showBackToTop="true" target="main"></app-footer>
